import React from "react";
import clsx from "clsx";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { useControlled } from "../utils";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      cursor: "pointer",
      border: "1px solid #eee",
      background: "#eee",
      borderRadius: theme.spacing(2),
      padding: 1,
      boxSizing: "border-box",
      userSelect: "none"
    },
    item: {
      height: 28,
      boxSizing: "border-box",
      lineHeight: "28px",
      padding: "0 10px",
      textAlign: "center",
      flex: 1,
      whiteSpace: "nowrap"
    },
    selected: {
      background: "white",
      borderRadius: theme.spacing(2),
      fontWeight: theme.typography.fontWeightMedium,
      boxShadow: "0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2)"
    },
    themeSelected: {
      background: theme.palette.primary.light,
      color: theme.palette.primary.main,
      borderRadius: theme.spacing(2),
      fontWeight: theme.typography.fontWeightMedium,
      border: "1px solid ".concat(theme.palette.primary.main)
    },
    lg: {
      height: 32,
      lineHeight: "32px"
    }
  };
});

var SwitchButtons = function SwitchButtons(_a) {
  var inputValue = _a.value,
      _b = _a.size,
      size = _b === void 0 ? "normal" : _b,
      _c = _a.useTheme,
      useTheme = _c === void 0 ? false : _c,
      options = _a.options,
      onChange = _a.onChange;
  var classes = useStyles();

  var _d = useControlled({
    controlled: inputValue,
    default: options && options.length && options[0].value
  }),
      value = _d[0],
      setValue = _d[1];

  function handleChange(v) {
    if (v === value) return;
    onChange && onChange(v);
    setValue(v);
  }

  return React.createElement(Grid, {
    className: classes.root,
    container: true
  }, options.map(function (item) {
    return React.createElement(Typography, {
      key: item.value,
      onClick: function onClick() {
        return handleChange(item.value);
      },
      variant: "body2",
      className: clsx(classes.item, size === "lg" && classes.lg, item.value === value ? useTheme ? classes.themeSelected : classes.selected : "")
    }, item.label);
  }));
};

export default SwitchButtons;